import type { EmailTemplateRefModel } from '../models/automation-api.models';

export type EmailAutomationRecipientType =
  | 'FixedEmail'
  | 'PersonField'
  | 'EmailField'
  | 'CardAssignee'
  | 'CardCreator';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmailRecipientType(raw: unknown): EmailAutomationRecipientType {
  const s = typeof raw === 'string' ? raw.trim() : '';
  if (
    s === 'FixedEmail'
    || s === 'PersonField'
    || s === 'EmailField'
    || s === 'CardAssignee'
    || s === 'CardCreator'
  ) {
    return s;
  }
  if (s === 'Fixed' || s === 'Email') return 'FixedEmail';
  return 'FixedEmail';
}

export function isEmailAutomationConfigComplete(
  config: Record<string, unknown> | null | undefined,
  templates?: readonly EmailTemplateRefModel[] | null
): boolean {
  const c = config ?? {};
  const templateKey = typeof c['templateKey'] === 'string' ? c['templateKey'].trim() : '';
  if (!templateKey) return false;
  if (templates?.length) {
    const t = templates.find((x) => x.key === templateKey);
    if (t && t.isActive === false) return false;
  }
  const dest = normalizeEmailRecipientType(c['recipientType'] ?? c['destinationType']);
  if (dest === 'FixedEmail') {
    const em = typeof c['targetEmail'] === 'string' ? c['targetEmail'].trim() : '';
    return EMAIL_RE.test(em);
  }
  if (dest === 'PersonField' || dest === 'EmailField') {
    const wf =
      typeof c['recipientWorkflowFieldId'] === 'string' ? c['recipientWorkflowFieldId'].trim() : '';
    return !!wf;
  }
  return true;
}

export function isValidFixedEmail(value: string): boolean {
  return EMAIL_RE.test(value.trim());
}
